import React from "react";
import MasterDataPage from "@/components/MasterDataPage";
import { Truck } from "lucide-react";

export default function MasterVendors() {
  return (
    <MasterDataPage
      title="Vendors"
      subtitle="Glass suppliers, scan tools, targets, software providers"
      entity="vendors"
      testId="vendors"
      icon={Truck}
      defaultForm={{ name: "", category: "", contact_name: "", email: "", phone: "", website: "", payment_terms: "", notes: "" }}
      fields={[
        { key: "name", label: "Vendor Name", required: true, span: 2 },
        { key: "category", label: "Category", type: "select", options: ["glass", "parts", "scan_tools", "targets", "software", "training", "consumables", "other"] },
        { key: "contact_name", label: "Contact Name" },
        { key: "email", label: "Email", type: "email" },
        { key: "phone", label: "Phone" },
        { key: "website", label: "Website", span: 2 },
        { key: "payment_terms", label: "Payment Terms", type: "select", options: ["Net 15", "Net 30", "Net 45", "Net 60", "On Receipt"] },
        { key: "notes", label: "Notes", type: "textarea", span: 2 },
      ]}
      columns={[
        { key: "name", label: "Vendor" },
        { key: "category", label: "Category" },
        { key: "contact_name", label: "Contact" },
        { key: "email", label: "Email" },
        { key: "phone", label: "Phone" },
      ]}
    />
  );
}
